import {QuestionDifficulty} from '@domain/pom'
import {FilterMultiSelect, FilterMultiSelectProps} from '@widgets/common-filters'
import {useTranslation} from 'react-i18next'

import {FILTER_VALUE_SEPARATOR, FEATURE_NAMESPACE} from '../../consts'

export const PomQuestionCategoryFilter = <TName extends string>({
  ...props
}: Omit<FilterMultiSelectProps<QuestionDifficulty, TName>, 'options'>) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const options = Object.values(QuestionDifficulty).map((difficulty) => ({
    value: difficulty,
    label: t(`pomAction.questionDifficulty.${difficulty}`)
  }))

  return (
    <FilterMultiSelect
      {...props}
      options={options}
      renderValue={(value) =>
        value
          .map((difficulty) => t(`pomAction.questionDifficulty.${difficulty}`))
          .join(FILTER_VALUE_SEPARATOR)
      }
    />
  )
}
